import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useCurrentUser } from '../hooks/useCurrentUser';
import Firm from '@/features/firms/Firm';
import MatterDetail from '@/features/firms/MatterDetail';
const AllFinixData = lazy(() =>
  import('@/features/finix/AllFinixData').then((m) => ({ default: m.default })),
);
const AllFinixIdentitiesScreen = lazy(
  () => import('@/features/finix/AllFinixIdentitiesScreen'),
);
const AllFinixPaymentInstrumentsScreen = lazy(
  () => import('@/features/finix/AllFinixPaymentInstrumentsScreen'),
);
const AllFinixMerchantsScreen = lazy(
  () => import('@/features/finix/AllFinixMerchantsScreen'),
);
const AllFinixTransfersScreen = lazy(
  () => import('@/features/finix/AllFinixTransfersScreen'),
);
const FinixObjectDetailPage = lazy(
  () => import('@/features/finix/components/FinixObjectDetailPage'),
);
const AuthenticatedAppLayout = lazy(() => import('./AuthenticatedAppLayout'));
const UnauthenticatedAppLayout = lazy(
  () => import('./UnauthenticatedAppLayout'),
);
const Dashboard = lazy(() => import('@/features/dashboard/Dashboard'));
const CloudFunctions = lazy(
  () => import('@/features/cloudFunctions/CloudFunctions'),
);
const FirestoreBrowser = lazy(
  () => import('@/features/firestoreBrowser/FirestoreBrowser'),
);
const Analytics = lazy(() =>
  import('@/features/analytics/Analytics').then((m) => ({
    default: m.Analytics,
  })),
);
const EmailPasswordLoginForm = lazy(
  () => import('@/features/auth/components/EmailPasswordLoginForm'),
);

const AppRoutes = () => {
  const userState = useCurrentUser();

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path='/'>
          {userState.type === 'authenticated' ? (
            <Route
              element={<AuthenticatedAppLayout authUser={userState.user} />}
            >
              <Route index element={<Navigate to='dashboard' replace />} />
              <Route path='dashboard' element={<Dashboard />} />
              <Route path='firms/:firmId' element={<Firm />} />
              <Route
                path='firms/:firmId/matters/:matterId'
                element={<MatterDetail />}
              />
              <Route path='cloud-functions' element={<CloudFunctions />} />
              <Route
                path='firestore-browser/*'
                element={<FirestoreBrowser />}
              />
              <Route path='analytics' element={<Analytics />} />
              <Route path='finix-data' element={<AllFinixData />} />
              <Route
                path='finix-data/identities'
                element={<AllFinixIdentitiesScreen />}
              />
              <Route
                path='finix-data/payment-instruments'
                element={<AllFinixPaymentInstrumentsScreen />}
              />
              <Route
                path='finix-data/merchants'
                element={<AllFinixMerchantsScreen />}
              />
              <Route
                path='finix-data/transfers'
                element={<AllFinixTransfersScreen />}
              />
              <Route
                path='finix-data/identities/:id'
                element={<FinixObjectDetailPage objectType='identity' />}
              />
              <Route
                path='finix-data/merchants/:id'
                element={<FinixObjectDetailPage objectType='merchant' />}
              />
              <Route
                path='finix-data/payment-instruments/:id'
                element={
                  <FinixObjectDetailPage objectType='payment-instrument' />
                }
              />
              <Route
                path='finix-data/transfers/:id'
                element={<FinixObjectDetailPage objectType='transfer' />}
              />
              <Route
                path='*'
                element={<Navigate to='/dashboard' replace={true} />}
              />
            </Route>
          ) : userState.type === 'unauthenticated' ? (
            <Route element={<UnauthenticatedAppLayout />}>
              <Route index element={<Navigate to='login' replace />} />

              <Route path='login' element={<EmailPasswordLoginForm />} />

              <Route path='*' element={<Navigate to='/login' replace />} />
            </Route>
          ) : null}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
